<script setup>
import { CenterModal, Icon, ModalButtons, DmButton } from 'dmui_components'
import useReportTypeMgmt from '../composables/useReportTypeMgmt.js'

const { getMappedDocumentType } = useReportTypeMgmt()

defineEmits(['cancel', 'update:monitoring'])
defineProps({
	orgName: {
		type: String,
		default: undefined
	},
	documentType: {
		type: String,
		default: undefined,
		validator: (value) => ['fin', 'susty'].includes(value)
	}
})
</script>
<template>
	<CenterModal>
		<div>
			<h1 class="primary-header"><Icon name="uil-times" size="large" /><span>Not publishing</span></h1>
			<p class="secondary-text">
				<span class="secondary-text bold">Confirmation needed:</span> {{ orgName }} no longer publishes
				<span class="secondary-text bold">{{ getMappedDocumentType(documentType) }}</span> reports?
			</p>
			<p class="secondary-text">Manage this option in the Organizations menu tab</p>
			<ModalButtons>
				<DmButton id="cancel" class="transparent" @click.prevent="$emit('cancel')">Cancel</DmButton>
				<DmButton id="delete" class="danger" @click.prevent="$emit('update:monitoring')">Confirm</DmButton>
			</ModalButtons>
		</div>
	</CenterModal>
</template>
<style scoped lang="less">
.center-modal-panel > div {
	padding: 24px;
	display: flex;
	flex-direction: column;
	.primary-header {
		display: flex;
		gap: @micro;
		align-items: center;
		margin-bottom: @midi;
	}
}
</style>
